<!--<template>-->
<!--  <div>-->
<!--    <Watermark :text="text"></Watermark>-->
<!--    <div style="display: flex">-->
<!--      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">-->
<!--        <el-menu-item v-if="hasAccountPermission" index="1">-->
<!--          <span>账号矩阵</span>-->
<!--        </el-menu-item>-->
<!--        <el-menu-item v-if="hasNamePermission" index="2">-->
<!--          <span>责任名单</span>-->
<!--        </el-menu-item>-->
<!--        <el-menu-item v-if="hasReportPermission" index="3">-->
<!--          <span>佳作通报</span>-->
<!--        </el-menu-item>-->
<!--        <el-menu-item v-if="hasPromptPermission" index="4">-->
<!--          <span>审读提示</span>-->
<!--        </el-menu-item>-->
<!--        <el-menu-item v-if="hasChangePermission" index="5">-->
<!--          <span>变更办理</span>-->
<!--        </el-menu-item>-->
<!--        <el-menu-item v-if="hasRecordPermission" index="6">-->
<!--          <span>差错记录</span>-->
<!--        </el-menu-item>-->
<!--      </el-menu>-->
<!--      &lt;!&ndash;      <el-button style="margin-left: auto;margin-right: 1rem; margin-top: 10px; margin-bottom: 10px" type="danger" round&ndash;&gt;-->
<!--      &lt;!&ndash;      @click="logout">退出登录</el-button>&ndash;&gt;-->

<!--    </div>-->
<!--&lt;!&ndash;    <router-view/>&ndash;&gt;-->
<!--  </div>-->
<!--</template>-->

<!--<script>-->
<!--import { mapState } from 'vuex';-->
<!--import Watermark from '../components/Watermark';-->

<!--export default {-->
<!--  name: "Layout",-->
<!--  components: {-->
<!--    Watermark-->
<!--  },-->
<!--  data() {-->
<!--    return {-->
<!--      text:  '',-->
<!--      activeIndex: '',-->
<!--      role: ''-->
<!--    }-->
<!--  },-->

<!--  created() {-->
<!--    this.updateActiveIndex();-->
<!--    this.text = sessionStorage.getItem('userName');-->
<!--  },-->

<!--  watch: {-->
<!--    // 监听路由变化，动态更新 activeIndex-->
<!--    '$route'(to, from) {-->
<!--      this.updateActiveIndex();-->
<!--    }-->
<!--  },-->

<!--  computed: {-->
<!--    ...mapState({-->
<!--      user: state => state.user-->
<!--    }),-->

<!--    hasAccountPermission() {-->
<!--      return this.user.funcKeys.includes('data_analysis_business_number_account_select');-->
<!--    },-->
<!--    hasNamePermission() {-->
<!--      return this.user.funcKeys.includes('data_analysis_business_number_name_select');-->
<!--    },-->
<!--    hasReportPermission() {-->
<!--      return this.user.funcKeys.includes('data_analysis_business_number_report_select');-->
<!--    },-->
<!--    hasPromptPermission() {-->
<!--      return this.user.funcKeys.includes('data_analysis_business_number_prompt_select');-->
<!--    },-->
<!--    hasChangePermission() {-->
<!--      return this.user.funcKeys.includes('data_analysis_business_number_change_select');-->
<!--    },-->
<!--    hasRecordPermission() {-->
<!--      return this.user.funcKeys.includes('data_analysis_business_number_record_select');-->
<!--    },-->
<!--  },-->

<!--  methods: {-->
<!--    handleSelect(key) {-->
<!--      let targetRoute;-->
<!--      switch (key) {-->
<!--        case '1':-->
<!--          targetRoute = '/HomeView';-->
<!--          break;-->
<!--        case '2':-->
<!--          targetRoute = '/Responsibility';-->
<!--          break;-->
<!--        case '3':-->
<!--          targetRoute = '/Masterpieces';-->
<!--          break;-->
<!--        case '4':-->
<!--          targetRoute = '/Check';-->
<!--          break;-->
<!--        case '5':-->
<!--          targetRoute = '/handle';-->
<!--          break;-->
<!--        case '6':-->
<!--          targetRoute = '/mistake';-->
<!--          break;-->
<!--        default:-->
<!--          return;-->
<!--      }-->

<!--      if (this.$route.path !== targetRoute) {-->
<!--        this.$router.push(targetRoute).catch(err => {-->
<!--          if (err.name !== 'NavigationDuplicated') {-->
<!--            throw err;-->
<!--          }-->
<!--        });-->
<!--      }-->
<!--    },-->

<!--    updateActiveIndex() {-->
<!--      // 根据当前路由路径设置 activeIndex-->
<!--      const path = this.$route.path;-->
<!--      if (path === '/HomeView') {-->
<!--        this.activeIndex = '1';-->
<!--      } else if (path === '/Responsibility') {-->
<!--        this.activeIndex = '2';-->
<!--      } else if (path === '/Masterpieces') {-->
<!--        this.activeIndex = '3';-->
<!--      } else if (path === '/Check') {-->
<!--        this.activeIndex = '4';-->
<!--      } else if (path === '/handle') {-->
<!--        this.activeIndex = '5';-->
<!--      } else if (path === '/mistake') {-->
<!--        this.activeIndex = '6';-->
<!--      }-->
<!--    },-->

<!--    hasPermissionForRoute(route) {-->
<!--      switch (route) {-->
<!--        case '/HomeView':-->
<!--          return this.hasAccountPermission;-->
<!--        case '/Responsibility':-->
<!--          return this.hasNamePermission;-->
<!--        case '/Masterpieces':-->
<!--          return this.hasReportPermission;-->
<!--        case '/Check':-->
<!--          return this.hasPromptPermission;-->
<!--        case '/handle':-->
<!--          return this.hasChangePermission;-->
<!--        case '/mistake':-->
<!--          return this.hasRecordPermission;-->
<!--        default:-->
<!--          return false;-->
<!--      }-->
<!--    }-->
<!--  }-->
<!--}-->
<!--</script>-->


<!--<style>-->
<!--/* 可以根据需要添加样式 */-->
<!--</style>-->
<template>
  <div class="layout">
    <Watermark :text="text"></Watermark>
    <el-menu v-if="!$store.getters.isLoading" class="menu" router mode="horizontal" :default-active="$route.path"> <!-- 使用 router 属性绑定菜单到路由 -->
      <el-menu-item index="/HomeView"       v-if="hasAccountPermission">账号矩阵</el-menu-item>
      <el-menu-item index="/Responsibility" v-if="hasNamePermission"   >责任名单</el-menu-item>
      <el-menu-item index="/Masterpieces"   v-if="hasReportPermission" >佳作通报</el-menu-item>
      <el-menu-item index="/Check"          v-if="hasPromptPermission" >审读提示</el-menu-item>
      <el-menu-item index="/handle"         v-if="hasChangePermission" >变更办理</el-menu-item>
      <el-menu-item index="/mistake"        v-if="hasRecordPermission" >问题案例</el-menu-item>
      <el-menu-item index="/record"        v-if="hasWrongPermission" >稿件差错</el-menu-item>
    </el-menu>
    <div class="content">
      <router-view /> <!-- 用于显示子路由内容 -->
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Watermark from '../components/Watermark';

export default {
  name: "Menu",
  components: {
    Watermark
  },
  data() {
    return {
      text:  '',
      activeIndex: '',
      role: ''
    }
  },

  created() {
    this.text = sessionStorage.getItem('userName');
    if (!this.user.funcKeys.length) {
      this.$store.dispatch('fetchUser');  // 如果权限没有加载，发起请求
    }
  },



  computed: {
    ...mapState({
      user: state => state.user
    }),
    isPermissionsReady() {
      console.log(this.user && this.user.funcKeys && this.user.funcKeys.length)
      return this.user && this.user.funcKeys && this.user.funcKeys.length > 0;
    },
    hasAccountPermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_account_select');
    },
    hasNamePermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_name_select');
    },
    hasReportPermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_report_select');
    },
    hasPromptPermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_prompt_select');
    },
    hasChangePermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_change_select');
    },
    hasRecordPermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_record_select');
    },
    hasWrongPermission() {
      return this.user.funcKeys.includes('data_analysis_business_number_wrong_select');
    },
  },

  methods: {

  }
}
</script>

<style scoped>


</style>
